<template>
  <v-container class="pa-0">
    <div class="pa-4">
      <picture>
        <source
          media="(max-width: 600px)"
          srcset="@/assets/images/cover-mobile.jpg"
        />
        <img
          src="@/assets/images/cover-desktop.jpg"
          alt="Cover"
          class="d-block elevation-4"
          :style="{
            width: '100%',
            maxHeight: '300px',
            objectFit: 'cover',
            borderRadius: '16px',
          }"
        />
      </picture>
    </div>
    <div class="pa-4 mt-n4">
      <div
        class="text-center pa-4 elevation-4"
        style="
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: space-evenly;
          background-color: #0a5188;
          border-radius: 16px;
        "
      >
        <div style="flex-grow: 1; flex-basis: 0" class="stepcolor">
          <div class="stepcircle">1</div>
          <div class="text-center">Info</div>
        </div>
        <div style="flex-grow: 1; flex-basis: 0" class="circlesmall">
          <v-icon :color="step < 2 ? '#3988c6' : 'white'"
            >mdi-circle-small</v-icon
          >
        </div>
        <div
          style="flex-grow: 1; flex-basis: 0"
          class="stepcolor"
          :class="{ 'stepcolor-none': step < 2 }"
        >
          <div class="stepcircle" :class="{ 'stepborder-none': step < 2 }">
            2
          </div>
          <div class="text-center">Address</div>
        </div>
        <div style="flex-grow: 1; flex-basis: 0" class="circlesmall">
          <v-icon :color="step < 3 ? '#3988c6' : 'white'"
            >mdi-circle-small</v-icon
          >
        </div>
        <div
          style="flex-grow: 1; flex-basis: 0"
          class="stepcolor"
          :class="{ 'stepcolor-none': step < 3 }"
        >
          <div :class="{ 'stepborder-none': step < 3 }" class="stepcircle">
            3
          </div>
          <div>Experience</div>
        </div>
      </div>
    </div>
    <div v-show="step == 1">
      <step-1></step-1>
    </div>
    <div v-show="step == 2">
      <step-2></step-2>
    </div>
    <div v-show="step == 3">
      <step-3></step-3>
    </div>
  </v-container>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
export default {
  components: {
    Step1,
    Step2,
    Step3,
  },
  data() {
    return {};
  },
  computed: {
    step() {
      return this.$store.state.step;
    },
  },
  beforeCreate() {
    this.$store.state.bgcolor = "white";
  },
  beforeDestroy() {
    this.$store.state.bgcolor = "#0a5188";
  },
};
</script>

<style lang="scss">
// .v-stepper__header {
//   box-shadow: none;
// }
.stepcolor {
  color: white;
}
.stepcircle {
  margin-left: auto;
  margin-right: auto;
  border: 1px solid white;
  color: white;
  height: 30px;
  width: 30px;
  line-height: 30px;
  border-radius: 50px;
}
.circlesmall {
  color: white;
}
.stepcolor-none {
  color: #3988c6 !important;
}
.stepborder-none {
  border: 1px solid #3988c6;
  color: #3988c6;
}
</style>
